import type { Theme } from '@mui/material/styles'

// A year pick fires onChange before a day is chosen, so the board's calendars offer days only.
export const DAY_ONLY_CALENDAR_VIEWS = ['day'] as const
export const ROUTE_COLUMN_V2_WIDTH = 380
export const UNASSIGNED_ROUTE_ID = '__unassigned__'
export const V2_BOX_SHADOW = (theme: Theme) => theme.shadows[1]
